import React from 'react';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import Bem from '../../../../lib/bemUtils/bem';
import { SVG, SVGIcon } from '../../../../components/atoms/SVG';

type AppLibraryElementLinkContentProps = {
  modifier?: Modifier<'small'>;
  src: string;
  icon?: SVGIcon;
};

export function AppIconListItem({ modifier, src, icon }: AppLibraryElementLinkContentProps) {
  return (
    <>
      {icon && (
        <span className="app-icon-list__svg">
          <SVG svgSpriteId={icon} />
        </span>
      )}
      <img
        className={Bem('app-icon-list__img', modifier)}
        src={src || 'data:,'}
        /* Decision for empty alt please compare
         * "https://w3c.github.io/alt-techniques/with-pictures.html#icon-images-0"
         * § 3.15 Icon Images */
        alt=""
      />
    </>
  );
}
